import { Setting } from 'types/back-office-settings';
import { AdministratorFieldNameControl } from '../AdministratorFieldNameControl';
import type { SettingSectionLayout } from '../settingLayout';

/** The "Contacts" section: its group bands and their rows, in page order. */
export const CONTACTS_SECTION: SettingSectionLayout = {
    anchor: 'contacts',
    groups: [
        {
            id: 'contacts-fields',
            rows: [
                { key: Setting.PERSON_TITLES_FREE_TEXT },
                { key: Setting.CORRESPONDENCE_ADDRESS },
                { key: Setting.IDENTITY_DOCUMENT_FIELDS },
                { key: Setting.OBFUSCATE_CONTACT_PERSONAL_ID_CODE },
                {
                    key: Setting.ADMINISTRATOR_FIELD,
                    sub: [{ kind: 'value', Content: AdministratorFieldNameControl }],
                },
            ],
        },
        {
            id: 'contacts-defaults',
            rows: [{ key: Setting.NEW_CONTACTS_DEFAULT_TO_CLIENT }, { key: Setting.CONTACT_TYPE_CONVERSION }],
        },
        {
            id: 'contacts-indicators',
            rows: [{ key: Setting.NON_VERIFIED_CLIENT_ICON }, { key: Setting.OPPONENT_CHIP }],
        },
    ],
};
